// extracted by mini-css-extract-plugin
export default {"cSwitch":"cSwitch-FkEel","cSwitchCircle":"cSwitch-circle-kYD_g","cSwitchOpen":"cSwitch-open-H9QqX","cSwitchClose":"cSwitch-close-OeQ3W"};